
export const TEST_MODE = false//location.host === 'dev.steens.camp'// true

export const TEST_CARD = { // auto filled when in TEST_MODE
	cc_number: 4242424242424242,
	cc_exp_month: 3,
	cc_exp_year: 2026,
	cc_cvc: 123
}

const STRIPE_KEY_TEST = 'pk_test_Df02NEH9E9JTJU6p6d3QE6HW00z15qzNG4'
const STRIPE_KEY_LIVE = 'pk_live_Rr8Ps8gtuzQKYQEY3M5lAU43000MSVdZQM'

const STRIPE_KEY = TEST_MODE ? STRIPE_KEY_TEST : STRIPE_KEY_LIVE

export const GetStripeToken = function(cardData){
	return new Promise((resolve,reject)=>{
		Stripe.card.createToken(cardData, (status, resp)=>{
			if( resp.error )
				return reject(resp.error)
			
			resolve(resp)
		});
	})
}

Stripe.setPublishableKey(STRIPE_KEY);